import * as DeleteProjectTeamMemberTypes from 'src/actions/project/team-member/delete/Types';
import { DeleteProjectTeamMemberAction } from 'src/actions/project/team-member/delete/DeleteProjectTeamMember.actions';

export interface DeleteProjectTeamMemberState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: DeleteProjectTeamMemberState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function DeleteProjectTeamMemberReducer(state: DeleteProjectTeamMemberState = initialState,
                                               action: DeleteProjectTeamMemberAction): DeleteProjectTeamMemberState {
  switch (action.type) {
    case DeleteProjectTeamMemberTypes.DELETE_PROJECT_TEAM_MEMBER_ATTEMPT:
      return {...state, loading: true, error: false};
    case DeleteProjectTeamMemberTypes.DELETE_PROJECT_TEAM_MEMBER_SUCCESS:
      return {...state, loading: false, error: false};
    case DeleteProjectTeamMemberTypes.DELETE_PROJECT_TEAM_MEMBER_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project/team-members/DeleteProjectTeamMemberReducer.ts